import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "edb8bNgGY5ENIATkCU6QO3t", "FitNode", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, view, size, Widget, UITransform } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
var FitNode = (_dec = menu("fit/fitNode"), ccclass(_class = _dec(_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FitNode, _Component);

  function FitNode() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FitNode.prototype;

  // LIFE-CYCLE CALLBACKS:
  _proto.onLoad = function onLoad() {
    /**showAll 适配时 的缩放 */
    var canvasSize = view.getCanvasSize();
    var designSize = size(1280, 720);
    var preRateX = (this.node.position.x + designSize.width / 2) / designSize.width;
    var scaleForShowAll = Math.min(canvasSize.width / designSize.width, canvasSize.height / designSize.height);
    /**showAll 模式下 的实际展示宽高 */

    var realSize = size(designSize.width * scaleForShowAll, designSize.height * scaleForShowAll);
    /**showAll模式下， 将画布拉满全屏的最小缩放 */

    var scale_w = canvasSize.width / realSize.width;
    /**重置宽高 */

    var aimW = designSize.width * scale_w;
    var curPos = this.node.position;
    this.node.setPosition(aimW * preRateX, curPos.y);
    var uiTF = this.node.getComponent(UITransform);
    uiTF.setContentSize(size(uiTF.width * scale_w, uiTF.height));
    var allWidgets = this.node.getComponentsInChildren(Widget);

    for (var i = 0; i < allWidgets.length; i++) {
      allWidgets[i].updateAlignment();
    }
  };

  _proto.start = function start() {} // update (dt) {}
  ;

  return FitNode;
}(Component)) || _class) || _class);
export { FitNode as default };

_cclegacy._RF.pop();